export const FETCH_PORTFOLIO_BEGIN="FETCH_PORTFOLIO_BEGIN";
export const FETCH_PORTFOLIO_SUCCESS="FETCH_PORTFOLIO_SUCCESS";
export const FETCH_PORTFOLIO_FAILURE="FETCH_PORTFOLIO_FAILURE";

// All Contants Used Under Portfolio Menu are Used Here

export const FETCH_PORTFOLIO_LIST_BEGIN="FETCH_PORTFOLIO_LIST_BEGIN";
export const FETCH_PORTFOLIO_LIST_SUCCESS="FETCH_PORTFOLIO_LIST_SUCCESS";
export const FETCH_PORTFOLIO_LIST_FAILURE="FETCH_PORTFOLIO_LIST_FAILURE";

export const FETCH_PORTFOLIO_DETAIL_BEGIN="FETCH_PORTFOLIO_DETAIL_BEGIN";
export const FETCH_PORTFOLIO_DETAIL_SUCCESS="FETCH_PORTFOLIO_DETAIL_SUCCESS";
export const FETCH_PORTFOLIO_DETAIL_FAILURE="FETCH_PORTFOLIO_DETAIL_FAILURE";


export const FETCH_PORTFOLIO_TYPE_BEGIN="FETCH_PORTFOLIO_TYPE_BEGIN";
export const FETCH_PORTFOLIO_TYPE_SUCCESS="FETCH_PORTFOLIO_TYPE_SUCCESS";
export const FETCH_PORTFOLIO_TYPE_FAILURE="FETCH_PORTFOLIO_TYPE_FAILURE";


export const FETCH_PORTFOLIO_CURRENCY_BEGIN="FETCH_PORTFOLIO_CURRENCY_BEGIN";
export const FETCH_PORTFOLIO_CURRENCY_SUCCESS="FETCH_PORTFOLIO_CURRENCY_SUCCESS";
export const FETCH_PORTFOLIO_CURRENCY_FAILURE="FETCH_PORTFOLIO_CURRENCY_FAILURE";


export const FETCH_PORTFOLIO_CASH_BEGIN="FETCH_PORTFOLIO_CASH_BEGIN";
export const FETCH_PORTFOLIO_CASH_SUCCESS="FETCH_PORTFOLIO_CASH_SUCCESS";
export const FETCH_PORTFOLIO_CASH_FAILURE="FETCH_PORTFOLIO_CASH_FAILURE";


export const FETCH_PORTFOLIO_EXPENSE_BEGIN="FETCH_PORTFOLIO_EXPENSE_BEGIN";
export const FETCH_PORTFOLIO_EXPENSE_SUCCESS="FETCH_PORTFOLIO_EXPENSE_SUCCESS";
export const FETCH_PORTFOLIO_EXPENSE_FAILURE="FETCH_PORTFOLIO_EXPENSE_FAILURE";



export const FETCH_PORTFOLIO_CREDITFACILITY_BEGIN="FETCH_PORTFOLIO_CREDITFACILITY_BEGIN";
export const FETCH_PORTFOLIO_CREDITFACILITY_SUCCESS="FETCH_PORTFOLIO_CREDITFACILITY_SUCCESS";
export const FETCH_PORTFOLIO_CREDITFACILITY_FAILURE="FETCH_PORTFOLIO_CREDITFACILITY_FAILURE";


export const FETCH_PORTFOLIO_MANAGER_BEGIN="FETCH_PORTFOLIO_MANAGER_BEGIN";
export const FETCH_PORTFOLIO_MANAGER_SUCCESS="FETCH_PORTFOLIO_MANAGER_SUCCESS";
export const FETCH_PORTFOLIO_MANAGER_FAILURE="FETCH_PORTFOLIO_MANAGER_FAILURE";


export const FETCH_PORTFOLIO_TAXSTATUS_BEGIN="FETCH_PORTFOLIO_TAXSTATUS_BEGIN";
export const FETCH_PORTFOLIO_TAXSTATUS_SUCCESS="FETCH_PORTFOLIO_TAXSTATUS_SUCCESS";
export const FETCH_PORTFOLIO_TAXSTATUS_FAILURE="FETCH_PORTFOLIO_TAXSTATUS_FAILURE";


export const FETCH_PORTFOLIO_DISCRETIONARYSTATUS_BEGIN="FETCH_PORTFOLIO_DISCRETIONARYSTATUS_BEGIN";
export const FETCH_PORTFOLIO_DISCRETIONARYSTATUS_SUCCESS="FETCH_PORTFOLIO_DISCRETIONARYSTATUS_SUCCESS";
export const FETCH_PORTFOLIO_DISCRETIONARYSTATUS_FAILURE="FETCH_PORTFOLIO_DISCRETIONARYSTATUS_FAILURE";


export const FETCH_PORTFOLIO_ACCOUNT_LIST_BEGIN="FETCH_PORTFOLIO_ACCOUNT_LIST_BEGIN";
export const FETCH_PORTFOLIO_ACCOUNT_LIST_SUCCESS="FETCH_PORTFOLIO_ACCOUNT_LIST_SUCCESS";
export const FETCH_PORTFOLIO_ACCOUNT_LIST_FAILURE="FETCH_PORTFOLIO_ACCOUNT_LIST_FAILURE";


export const FETCH_PORTFOLIO_TOACCOUNT_LIST_BEGIN = "FETCH_PORTFOLIO_TOACCOUNT_LIST_BEGIN";
export const FETCH_PORTFOLIO_TOACCOUNT_LIST_SUCCESS = "FETCH_PORTFOLIO_TOACCOUNT_LIST_SUCCESS";
export const FETCH_PORTFOLIO_TOACCOUNT_LIST_FAILURE = "FETCH_PORTFOLIO_TOACCOUNT_LIST_FAILURE";

export const FETCH_PORTFOLIO_NONACCOUNT_LIST_BEGIN = "FETCH_PORTFOLIO_NONACCOUNT_LIST_BEGIN";
export const FETCH_PORTFOLIO_NONACCOUNT_LIST_SUCCESS = "FETCH_PORTFOLIO_NONACCOUNT_LIST_SUCCESS";
export const FETCH_PORTFOLIO_NONACCOUNT_LIST_FAILURE = "FETCH_PORTFOLIO_NONACCOUNT_LIST_FAILURE";



